export { AudioPopoverCover as SoundEffectsPopoverCover } from "../audio/AudioPopoverCover";
export type { AudioPopoverCoverProps as SoundEffectsPopoverCoverProps } from "../audio/AudioPopoverCover";
